import React from 'react';
import { Link } from 'react-router-dom';
import { LuHouse } from 'react-icons/lu';
import AdminThemeToggle from './AdminThemeToggle';

const AdminAuthShell = ({ children }) => (
  <div className="relative min-h-screen overflow-hidden bg-white transition-colors dark:bg-[#0a0a0a]">
    <div className="absolute right-5 top-5 z-30">
      <AdminThemeToggle />
    </div>

    <div className="grid min-h-screen lg:grid-cols-2">
      <div className="relative hidden overflow-hidden bg-black lg:flex lg:flex-col lg:justify-between">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/25 via-black to-black" />
        <div
          className="absolute inset-0 opacity-30"
          style={{
            backgroundImage:
              'radial-gradient(circle at 20% 80%, rgba(243,199,21,0.35) 0%, transparent 45%), radial-gradient(circle at 80% 20%, rgba(243,199,21,0.15) 0%, transparent 40%)',
          }}
        />
        <div className="absolute bottom-0 left-0 right-0 h-48 bg-gradient-to-t from-black/80 to-transparent" />

        <div className="relative z-10 p-10">
          <img src="/img/logo-white.png" alt="RAADSO TECH" className="h-10 w-auto object-contain" />
        </div>

        <div className="relative z-10 px-10 pb-16">
          <h2 className="text-4xl font-extrabold leading-tight text-white md:text-5xl">
            Let&apos;s Kick
            <br />
            <span className="text-primary">Now!</span>
          </h2>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-gray-300">
            Sign in with email verification to manage your website content, services, and dashboard securely.
          </p>
        </div>

        <div className="relative z-10 p-10">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-white/80 transition-colors hover:text-primary"
          >
            <LuHouse size={14} />
            Home
          </Link>
        </div>
      </div>

      <div className="relative flex min-h-screen flex-col items-center justify-center bg-[#f3f4f6] px-6 py-12 dark:bg-[#111111]">
        <div className="mb-6 flex w-full max-w-[420px] items-center gap-3 lg:hidden">
          <img src="/img/logo-black.png" alt="RAADSO TECH" className="h-8 w-auto object-contain dark:hidden" />
          <img src="/img/logo-white.png" alt="RAADSO TECH" className="hidden h-8 w-auto object-contain dark:block" />
          <p className="text-sm font-bold text-slate-700 dark:text-gray-200">Admin Portal</p>
        </div>

        <div className="relative z-10 w-full max-w-[420px] rounded-[2rem] border border-slate-100 bg-white px-8 py-10 shadow-[0_24px_60px_rgba(15,23,42,0.12)] dark:border-white/10 dark:bg-[#161616] dark:shadow-[0_24px_60px_rgba(0,0,0,0.45)] lg:-ml-24">
          {children}
        </div>
      </div>
    </div>
  </div>
);

export default AdminAuthShell;
